const faqItems = [
  {
    q: '菲菲影院需要注册才能观看吗？',
    a: '完全不需要！菲菲影院所有电影资源均可免费在线观看，无需注册、无需登录，打开网站即可畅享海量高清电影，零门槛观影体验。',
  },
  {
    q: '电影画质怎么样，有高清选项吗？',
    a: '菲菲影院提供最高1080P高清画质，大部分影片支持高清乃至超清播放。我们持续优化片源质量，确保你在不同网络环境下都能获得清晰流畅的观影体验。',
  },
  {
    q: '支持哪些设备观看电影？',
    a: '菲菲影院完美适配电脑、平板、手机等各类设备。无论你是在家用大屏观看，还是通勤路上用手机刷片，都能获得一致的流畅体验。',
  },
  {
    q: '新电影一般多久能上线？',
    a: '我们的内容团队每日更新片库，热门新片通常在院线下映后第一时间上线。同时我们也会持续补充经典老片和冷门佳作，满足不同影迷的口味。',
  },
  {
    q: '观看电影时会有广告干扰吗？',
    a: '菲菲影院以用户体验为核心，不会有弹窗广告或强制观看的视频广告，让你沉浸在纯粹的电影世界中，不受打扰。',
  },
  {
    q: '可以下载电影离线观看吗？',
    a: '菲菲影院为在线流媒体平台，支持随时随地在线观看。如需离线观影，建议使用我们的移动端APP，支持缓存功能，让你在没有网络时也能享受电影。',
  },
];

export default function FaqSection() {
  return (
    <section id="faq" className="py-14 md:py-20 bg-background-50 scroll-mt-20">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 text-center mb-3">常见问答</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">关于菲菲影院的常见问题，你想知道的都在这里</p>
        <div className="space-y-4">
          {faqItems.map((item) => (
            <div key={item.q} className="rounded-xl bg-background-100 p-5 md:p-6">
              <h3 className="text-base font-medium text-foreground-900 mb-2 flex items-start gap-3">
                <span className="w-6 h-6 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 text-xs font-bold shrink-0 mt-0.5">Q</span>
                {item.q}
              </h3>
              <p className="text-sm text-foreground-600 leading-relaxed pl-9">{item.a}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}